import React, { useState, useEffect, useRef } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../../components/headerNew/reedumptionHeader';
import Footer from '../../components/footer/redumptionFooter';
import { rilogout, logout } from "../../redux/actions/login";


const ReedumptionRoute = ({ component: Component, restricted, ...rest }) => {
    const history = useHistory();
    let dispatch = useDispatch();
    const [showButton, setShowButton] = useState(false);
    const stateData = useSelector(state => state.Auth);
    const [name, setName] = useState("");


    const handleLogout = () => {
        // window.location.href = "/ri/login";
        dispatch(rilogout())
    }

    let getItem = localStorage.getItem('pageUrl');
    if (getItem == "unclaimed") {
        dispatch(logout());
    }

    useEffect(() => {
        if (history.location.pathname == '/ri/login') {
            setShowButton(false)
        } else {
            setShowButton(true)
        }

        if (stateData && stateData.cvlData && stateData.cvlData.nameAsOnPan) {
            setName(stateData.cvlData.nameAsOnPan)
        }

    }, [])


    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        <React.Fragment>
            <Header logout={handleLogout} showButton={showButton} name={name} />

            <Route {...rest} render={props => (
                restricted ?
                    <Redirect to="/cancelRedemption" />
                    :
                    <div style={{ minHeight: "500px" }}>
                        <Component {...props} />
                    </div>

            )} />
            <Footer />
        </React.Fragment>
    );
};

export default ReedumptionRoute;